import { useLanguage } from "@/hooks/useLanguage";
import { Button } from "@/components/ui/button";
import { Chrome, Globe, Compass, Smartphone, MonitorSmartphone, Sparkles } from "lucide-react";

const browsers = [
  {
    id: 'chrome',
    name: 'Chrome',
    icon: Chrome,
    textKey: 'downloadChrome',
    url: 'https://chromewebstore.google.com/detail/phonetic-pro-text-convert/gkiponhaimpgmomdojpmiipjdaidoefb',
    available: true,
  },
  {
    id: 'edge',
    name: 'Edge',
    icon: Globe,
    textKey: 'downloadEdge',
    url: 'https://microsoftedge.microsoft.com/addons/detail/phonetic-pro-text-convert/dfoeomfhmgnhjhmimeidmopikanhacoi',
    available: true,
  },
  {
    id: 'firefox',
    name: 'Firefox',
    icon: MonitorSmartphone,
    textKey: 'comingSoon',
    url: '#',
    available: false,
  },
  {
    id: 'opera',
    name: 'Opera',
    icon: Compass,
    textKey: 'comingSoon',
    url: '#',
    available: false,
  },
  {
    id: 'safari',
    name: 'Safari',
    icon: Smartphone,
    textKey: 'comingSoon',
    url: '#',
    available: false,
  },
];

const Download = () => {
  const { t } = useLanguage();

  return (
    <section id="download" className="py-24 px-6">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-muted text-sm text-muted-foreground mb-4">
            <Sparkles className="w-3.5 h-3.5" />
            Available for All Browsers
          </div>
          <h2 className="text-3xl font-semibold mb-3">
            {t('downloadTitle') || 'Download for Free'}
          </h2>
          <p className="text-muted-foreground max-w-xl mx-auto">
            {t('downloadSubtitle') || 'Start converting text instantly. Free forever, no account needed.'}
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4 max-w-3xl mx-auto">
          {browsers.map((browser, index) => (
            <div 
              key={browser.id} 
              className="flex flex-col items-center text-center gap-3 animate-fade-in"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className={`
                bg-card border rounded-lg p-5 w-full aspect-square flex items-center justify-center 
                ${browser.available ? 'border-foreground/20' : 'border-border'}
                hover:border-foreground/30 transition-all
              `}>
                <browser.icon 
                  className={`w-8 h-8 ${browser.available ? 'text-foreground' : 'text-muted-foreground'}`} 
                />
              </div>
              <span className="font-medium text-sm">{browser.name}</span>
              <Button 
                className="w-full text-xs"
                variant={browser.available ? "default" : "outline"}
                size="sm"
                asChild={browser.available}
                disabled={!browser.available}
              >
                {browser.available ? (
                  <a href={browser.url} target="_blank" rel="noopener noreferrer">
                    {t(browser.textKey as any) || 'Download'}
                  </a>
                ) : (
                  <span className="text-muted-foreground">{t(browser.textKey as any) || 'Coming Soon'}</span>
                )}
              </Button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Download;
